import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The old contractor record and create page, kept only as a redirect — see `contractors.index.tsx`.
 *
 * One route for both, because `/contractors/new` lands here as a `$ref` of "new" and forwards to
 * `/maintenance/contractors/new`, where the static route outranks the record. Anything else is
 * forwarded as it came, and the record page answers a bad ref the way it always has.
 */
export const Route = createFileRoute('/contractors/$ref')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/maintenance/contractors/$ref',
      params: { ref: params.ref },
      replace: true,
    });
  },
});
